import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { MaskGroup } from '@/shared/config';
import { useAppSelector } from '@/shared/hooks';
import { Tooltip } from '@/shared/ui';

// I think we should unite maskFilters entitiy with maskFilters feature
import { maskFiltersDefaultMessages } from '../../config/i18n';
import * as maskFilterModel from '../../model';

import styles from './MaskFilterButton.module.scss';

type MaskFilterButtonProps = {
  active: boolean;
  filterGroup: MaskGroup;
  onClick: (filterGroup: MaskGroup) => void;
  className?: string;
  testID?: string;
};

const buttonColors = {
  perio: styles.maskFilterPerio,
  restorative: styles.maskFilterRestorative,
  endo: styles.maskFilterEndo,
  chart: styles.maskFilterChart,
};

export const MaskFilterButton: FC<MaskFilterButtonProps> = (props) => {
  const { className, testID, active, filterGroup, onClick } = props;

  const { formatMessage } = useIntl();
  const disabled = useAppSelector(
    maskFilterModel.selectors.selectMaskFilterDisabled(filterGroup),
  );

  const button = (
    <button
      data-testid={testID}
      data-component="mask-filter-button"
      data-id={filterGroup}
      className={cn(
        className,
        styles.container,
        'p4',
        active && buttonColors[filterGroup],
      )}
      type="button"
      disabled={disabled}
      onClick={() => onClick(filterGroup)}
    >
      {formatMessage(maskFiltersDefaultMessages[filterGroup])}
    </button>
  );

  if (disabled) {
    return (
      <Tooltip.Primary
        content={formatMessage({
          id: 'mask.filter.noMasksAvailable',
          defaultMessage: 'No masks available for this group',
        })}
      >
        {button}
      </Tooltip.Primary>
    );
  }

  return button;
};
